import React, { Component } from "react";
import {
  Segment,
  Menu,
  Input,
  Icon,
  Table,
  Pagination,
  Popup,
  Label,
  Select,
  Button,
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import client from "../../shared/feathers";
import SellerSingleCompact from "../Sellers/Single/compact";
import Moment from "react-moment";
import moment from "moment";

function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}
class ReceiptsList extends Component {
  state = {
    query: {
      status: { status: { $nin: ["canceld"] } },
    },
    data: {
      total: 1,
      limit: 1,
      data: [],
    },
    customers: [],
    users: [],
    page: 1,
    loading: true,
  };

  async componentDidMount() {
    await this.search("users");
    document.title = "Angebote";
    this.update();
  }
  async search(field, query) {
    this.setState({
      [field]: (await client.service(field).find({ query })).data.map(
        (elm, index) => ({
          key: elm.id,
          value: elm.id,
          text:
            elm.firstname || elm.company
              ? elm.company
                ? elm.company
                : elm.firstname + " " + elm.lastname
              : elm.manufacturer + " " + elm.type,
          description:
            elm.firstname || elm.company ? elm.id : elm.identification,
        })
      ),
    });
  }
  changePage(event, data) {
    this.setState({ loading: true, page: data.activePage }, () =>
      this.update()
    );
  }
  update() {
    this.setState({ loading: true });
    if (this.reactive) {
      this.reactive.unsubscribe();
    }
    this.reactive = client
      .service("receipts")
      .watch()
      .find({
        query: {
          $sort: { id: -1 },
          $and: [...Object.values(this.state.query)],
          $skip:
            this.state.page * this.state.data.limit - this.state.data.limit,
          ...this.props.query,
        },
      })
      .subscribe(async (data) => this.setState({ data, loading: false }));
  }
  componentWillUnmount() {
    if (this.reactive) {
      this.reactive.unsubscribe();
    }
  }
  changeFilter(name, value) {
    if ((name == "customer_id" || name == "user_id") && value) {
      this.setState(
        {
          query: {
            ...this.state.query,
            [name]: { [name]: value },
          },
        },
        () => this.update()
      );
    } else {
      this.setState(
        {
          query: {
            ...this.state.query,
            [name]: { [name]: { $like: "%" + value + "%" } },
          },
        },
        () => this.update()
      );
    }
  }
  async duplicate(entry) {
    let newEntry = {
      ...entry,
      status: "open",
      created_at: moment().format("YYYY-MM-DD"),
      until: moment().add(15, "days").format("YYYY-MM-DD"),
    };
    delete newEntry["id"];
    let result = await client.service("receipts").create(newEntry);
    this.props.history.push("/receipts/view/" + result.id);
  }
  // {
  //   "id": 1349,
  //   "user_id": 3,
  //   "customer_id": 1461,
  //   "status": "send",
  //   "document": "angebot_1349_2022-02-22_3_b94db470-93d4-11ec-bd1f-0b7f2115bc3b.pdf",
  //   "products": "[{\"id\":18,\"sku\":\"6220\",\"product_name\":\"Display Ads\",\"channel\":\"Online\",\"salesline\":\"Galeria\",\"category\":null,\"unit\":\"AI\",\"unit2\":\"TKP\",\"amount\":\"295000\",\"single_price\":80,\"surcharge\":0,\"discount\":85,\"department\":null,\"format\":\"970x250, 800x250 (Mobile 320x150) / Home, Produktlisting\",\"description\":\"L'Oreal Lifestyle - ab KW12: Branding-orientierte Kampagnenfläche mit individuellem Targeting.\",\"created_at\":null,\"updated_at\":null,\"intern\":\"Mindestbuchungsvolumen 5.000 Euro\"}]",
  //   "customer": "{\"id\":1461,\"company_id\":7448152,\"owner_id\":{\"id\":11930550,\"name\":\"Matthias Heilig\",\"email\":\"m.heilig@signacrmsolutions.de\",\"has_pic\":1,\"pic_hash\":\"956f66ea89ab6b4b68fc973ce27c562e\",\"active_flag\":true,\"value\":11930550},\"name\":\"GALERIA Karstadt Kaufhof GmbH\",\"open_deals_count\":56,\"related_open_deals_count\":0,\"closed_deals_count\":23,\"related_closed_deals_count\":0,\"email_messages_count\":249,\"people_count\":25,\"activities_count\":5,\"done_activities_count\":5,\"undone_activities_count\":0,\"files_count\":100,\"notes_count\":5,\"followers_count\":3,\"won_deals_count\":23,\"related_won_deals_count\":0,\"lost_deals_count\":0,\"related_lost_deals_count\":0,\"active_flag\":true,\"category_id\":null,\"picture_id\":null,\"country_code\":null,\"first_char\":\"g\",\"update_time\":\"2022-02-22 11:42:17\",\"add_time\":\"2021-05-11 12:18:50\",\"visible_to\":\"7\",\"next_activity_date\":null,\"next_activity_time\":null,\"next_activity_id\":null,\"last_activity_id\":3517,\"last_activity_date\":\"2022-01-20\",\"label\":null,\"address\":\"Theodor-Althoff-Straße 2, 45133 Essen, Deutschland\",\"address_subpremise\":\"\",\"address_street_number\":\"2\",\"address_route\":\"Theodor-Althoff-Straße\",\"address_sublocality\":\"Stadtbezirke IX\",\"address_locality\":\"Essen\",\"address_admin_area_level_1\":\"Nordrhein-Westfalen\",\"address_admin_area_level_2\":\"Düsseldorf\",\"address_country\":\"Deutschland\",\"address_postal_code\":\"45133\",\"address_formatted_address\":\"Theodor-Althoff-Straße 2, 45133 Essen, Deutschland\",\"70b879b501eefad53b3d17a48ee3a9b259d29202\":\"www.galeria.de\",\"2d4b4ba485b62308455f41334831b74ffb74431c\":null,\"90de8a4b312009afd8917dbb7d1af72abfc7af2c\":null,\"9cc3194ff3d00843027dbc89735c8c64fd3ee428\":null,\"4de46706115917a91450b396634f96ebb8b2d5fb\":\"68\",\"6fd0d23f0f34d591901592b67b2290fc15a740b4\":null,\"c2a712bed37792221bef64543d4864142acafc9e\":\"51\",\"22894f85aeb69f9284d7b755160d3efc696dbae4\":null,\"c4d6088ae859af017d1965eefbea575fe9c97360\":null,\"cc_email\":\"laya@pipedrivemail.com\",\"bd77c39ab8691bb39ff4c18287fe12344f0b47ae\":null,\"0712c1ce5baacc1aeecccaaea547b73f425a9f95\":\"41357252\",\"d502f616427db68335f1617ae9cfaeca0bacc705\":\"https://my.sevdesk.de/#/crm/detail/id/41357252\",\"863f954ae7b1fd23cddeff7723541a57bfc72bbe\":null,\"7658f59cb8287d7a17415a76d889d2f4c9a071a8\":null,\"owner_name\":\"Matthias Heilig\",\"edit_name\":true,\"last_activity\":{\"id\":3517,\"company_id\":7448152,\"user_id\":11930550,\"done\":true,\"type\":\"task\",\"reference_type\":null,\"reference_id\":null,\"conference_meeting_client\":null,\"conference_meeting_url\":null,\"due_date\":\"2022-01-20\",\"due_time\":\"\",\"duration\":\"24:00\",\"busy_flag\":false,\"add_time\":\"2021-12-02 14:58:04\",\"marked_as_done_time\":\"2022-02-07 09:37:12\",\"last_notification_time\":null,\"last_notification_user_id\":null,\"notification_language_id\":2,\"subject\":\"Casio - Reporting Vorbereitung mit Isabelle\",\"public_description\":\"\",\"calendar_sync_include_context\":false,\"location\":\"\",\"org_id\":1461,\"person_id\":1660,\"deal_id\":2441,\"lead_id\":null,\"project_id\":null,\"active_flag\":true,\"update_time\":\"2022-02-07 09:37:13\",\"update_user_id\":11930550,\"gcal_event_id\":null,\"google_calendar_id\":null,\"google_calendar_etag\":null,\"source_timezone\":null,\"rec_rule\":null,\"rec_rule_extension\":null,\"rec_master_activity_id\":null,\"conference_meeting_id\":null,\"note\":null,\"created_by_user_id\":11930550,\"location_subpremise\":null,\"location_street_number\":null,\"location_route\":null,\"location_sublocality\":null,\"location_locality\":null,\"location_admin_area_level_1\":null,\"location_admin_area_level_2\":null,\"location_country\":null,\"location_postal_code\":null,\"location_formatted_address\":null,\"attendees\":null,\"participants\":[{\"person_id\":1660,\"primary_flag\":true}],\"series\":null,\"org_name\":\"GALERIA Karstadt Kaufhof GmbH\",\"person_name\":\"Rodja Schultz\",\"deal_title\":\"G_CASIO_Uhren_Weihnachten-WKZ\",\"lead_title\":null,\"owner_name\":\"Matthias Heilig\",\"person_dropbox_bcc\":\"laya@pipedrivemail.com\",\"deal_dropbox_bcc\":\"laya+deal2441@pipedrivemail.com\",\"assigned_to_user_id\":11930550,\"type_name\":\"Aufgabe\",\"lead\":null},\"next_activity\":null}",
  //   "until": "2022-03-08T23:00:00.000Z",
  //   "deal_name": "G_L'Oreal_DisplayAds_Lifestyle_KW12-22",
  //   "taxfree": 0,
  //   "deal_id": 2684,
  //   "created_at": "2022-02-21T23:00:00.000Z",
  //   "updated_at": null,
  //   "contact_id": 1741,
  //   "contact_name": "Christian Mönninger",
  //   "ustd": null,
  //   "timerange": "KW 12 - 2022",
  //   "supplier_id": null,
  //   "supplier_name": null
  // }
  async syncAll() {
    this.setState({ loading: true });
    let { data } = await client
      .service("receipts")
      .find({ query: { $limit: 10000000000 } });
    data = data.map((el) => ({
      ...el,
      created_at: moment(el["created_at"]).format("DD-MM-YYYY"),
      until: moment(el["created_at"]).format("DD-MM-YYYY"),
      products: JSON.parse(el["products"]),
      customer: JSON.parse(el["customer"]),
    }));
    for (let entry of data) {
      if (entry.id > 1053) {
        try {
          await client
            .service("deals")
            .update(entry.deal_id, {
              supplier_name: entry.supplier_name,
              supplier_id: entry.supplier_id,
              receiptnr: "#" + pad(entry.id, 4),
              taxfree: entry.taxfree,
              products: entry.products,
              document: entry.document,
            });
        } catch (e) {
          console.log("ERR");
        }
      }
    }
    this.setState({ loading: false });
  }

  async sendPipedrive(data) {}
  render() {
    return (
      <Segment.Group style={{ padding: 0 }} {...this.props.SegmentProps}>
        {/* <Menu.Item onClick={this.syncAll.bind(this)} ><Icon name="refresh" /> Syncronisieren</Menu.Item> */}
        <Table
          selectable
          attached="top"
          celled
          size="small"
          {...this.props.TableProps}
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell collapsing>Ang. Nr.</Table.HeaderCell>
              <Table.HeaderCell>Kunde</Table.HeaderCell>
              <Table.HeaderCell>Deal</Table.HeaderCell>
              <Table.HeaderCell>Produkte</Table.HeaderCell>
              <Table.HeaderCell>Verkäufer</Table.HeaderCell>
              <Table.HeaderCell>Datum</Table.HeaderCell>
              <Table.HeaderCell>Ablauf</Table.HeaderCell>
              <Table.HeaderCell collapsing>Status</Table.HeaderCell>
              <Table.HeaderCell collapsing></Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell
                collapsing
                style={{ padding: 5, backgroundColor: "#fff" }}
              >
                <Input
                  onChange={(e, { name, value }) =>
                    this.changeFilter(name, value)
                  }
                  name="id"
                  fluid
                  transparent
                  size="mini"
                />
              </Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 0 }}></Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 5, backgroundColor: "#fff" }}>
                <Input
                  onChange={(e, { name, value }) =>
                    this.changeFilter(name, value)
                  }
                  name="deal_name"
                  icon="search"
                  fluid
                  transparent
                  size="mini"
                />
              </Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 0 }}></Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 0 }}>
                <Select
                  noResultsMessage="Es wurden keine Mitarbeiter gefunden."
                  search
                  onSearchChange={(e, { searchQuery }) =>
                    this.search("users", {
                      $or: [
                        { firstname: { $like: "%" + searchQuery + "%" } },
                        { lastname: { $like: "%" + searchQuery + "%" } },
                        { id: { $like: "%" + searchQuery + "%" } },
                      ],
                    })
                  }
                  search={(options) => this.state.users}
                  options={this.state.users}
                  style={{ border: "0", height: 20 }}
                  onChange={(e, { name, value }) =>
                    this.changeFilter(name, value)
                  }
                  clearable
                  transparent
                  name="user_id"
                  fluid
                />
              </Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 5, backgroundColor: "#fff" }}>
                <Input
                  onChange={(e, { name, value }) =>
                    this.changeFilter(name, value)
                  }
                  name="created_at"
                  icon="search"
                  fluid
                  transparent
                  size="mini"
                />
              </Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 5, backgroundColor: "#fff" }}>
                <Input
                  onChange={(e, { name, value }) =>
                    this.changeFilter(name, value)
                  }
                  name="until"
                  icon="search"
                  fluid
                  transparent
                  size="mini"
                />
              </Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 0 }}>
                <Select
                  style={{ border: "0", height: 20 }}
                  options={[
                    { key: "open", value: "open", text: "Offen" },
                    { key: "canceld", value: "canceld", text: "Gelöscht" },
                    { key: "send", value: "send", text: "Gesendet" },
                  ]}
                  onChange={(e, { name, value }) =>
                    this.changeFilter(name, value)
                  }
                  clearable
                  text=""
                  transparent
                  name="status"
                  fluid
                />
              </Table.HeaderCell>
              <Table.HeaderCell style={{ padding: 0 }}></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.state.data.data.map((entry, id) => (
              <Table.Row key={entry.id} style={{ cursor: "pointer" }}>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  #{pad(entry.id, 4)}
                </Table.Cell>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  <Popup
                    trigger={
                      <div>
                        {JSON.parse(entry.customer)
                          ? JSON.parse(entry.customer).name
                          : ""}
                      </div>
                    }
                    content={
                      (JSON.parse(entry.customer)
                        ? JSON.parse(entry.customer).address
                        : "") + ""
                    }
                    header={
                      (JSON.parse(entry.customer)
                        ? JSON.parse(entry.customer).name
                        : "") + ""
                    }
                    basic
                  />
                </Table.Cell>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  <small>({entry.deal_id})</small> {entry.deal_name}{" "}
                </Table.Cell>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  {JSON.parse(entry.products).length}
                </Table.Cell>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  <SellerSingleCompact seller_id={entry.user_id} />
                </Table.Cell>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  <Moment format="DD.MM.YYYY">{entry.created_at}</Moment>
                </Table.Cell>
                <Table.Cell
                  onClick={() =>
                    this.props.history.push("/receipts/view/" + entry.id)
                  }
                >
                  <Moment format="DD.MM.YYYY">{entry.until}</Moment>
                </Table.Cell>
                <Table.Cell>
                  {/* {entry.status=="open"&& <Label color="red" >Offen</Label>} */}
                  {entry.status == "canceld" && (
                    <Label color="red" basic>
                      Gelöscht
                    </Label>
                  )}
                  {entry.status == "send" && (
                    <Label color="green">Gesendet</Label>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <Button
                    size="tiny"
                    icon="external"
                    onClick={() => this.duplicate(entry)}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        {!this.props.noPagination && (
          <Pagination
            onPageChange={this.changePage.bind(this)}
            attached="bottom"
            boundaryRange={2}
            siblingRange={2}
            fluid
            defaultActivePage={this.state.page}
            totalPages={Math.ceil(
              this.state.data.total / this.state.data.limit
            )}
          />
        )}
      </Segment.Group>
    );
  }
}

export default withRouter(ReceiptsList);
